import React from "react";
import {Link, withRouter} from "react-router-dom";
import {projectStatusMap} from "../../../components/ProjectStatusMap";
import BootstrapTable from 'react-bootstrap-table-next';
import { Container, Dropdown, DropdownButton, Spinner } from 'react-bootstrap';
import 'react-bootstrap-table/dist/react-bootstrap-table.min.css';
import '../../../containers/startproj/startproj.css';
import ShowDeleteJobJournalDialog from "./DeleteJobJournalDialog";
import {isViewOnlyOrExternalView} from "../../../utils/UserInfo";
import EmptyView from '../../../components/EmptyView';
import JobJournalCommentsIcon from "./Comments/JobJournalCommentsIcon";
import {projectStatusCodeMap} from "../../../components/ProjectStatusCodeMap";
import { Col, Row } from "react-flexbox-grid";
import { Checkbox, DatePicker, Input, Table, Button, Empty } from "antd";
import { FilterFilled } from "@ant-design/icons";
import moment from "moment";
import { DatePickerAndDropdownComponent, SearchAndDropdownComponent, commonDateSorter, commonFilter } from "utils/AntdTableFunctions";

function JournalList(props)
{
    const {
        jobJournalList,
        project,
        refresh,
        refreshJobJournals,
        setViewFormDialog,
        setEditFormDialog,
        setNewFormDialog,
        handleRefreshCall
    } = props;

    function ViewCellFormatter(cell, row)
    {
        const projectId = project.id;
        const status = projectStatusMap[project.projectStatus];
        return (<Link to={`#`} onClick={() => setViewFormDialog(projectId,status, row)}><strong>{row.title}</strong></Link>);
    }

    function EditCellFormatter(cell, row) {
        const projectId = project.id;
        const status = projectStatusMap[project.projectStatus];
        //return (<Link to={`#`} onClick={() => setEditFormDialog(projectId,status, row)}><strong>Edit</strong></Link>);
        setEditFormDialog(projectId,status, row);
    }

    function DeleteCellFormatter(cell, row)
    {
        ShowDeleteJobJournalDialog(project.id, row, handleRefreshCall);
    }

    function CommentCellFormatter(cell,jobJournalRow)
    {
        //let project = this.props.project;
        let props = {project,jobJournalRow};
        return(<div style={{ display: 'inline-block' }}><JobJournalCommentsIcon {...props} /></div>);
    }

    function handleCreate()
    {
        const projectId = project.id;
        const status = projectStatusMap[project.projectStatus];
        const id = "new";
        setNewFormDialog(projectId, status);
    }

    const NoDataIndication = () => (
        refresh || refreshJobJournals ? <Spinner animation='border' variant='primary' /> : <EmptyView />
    );

    function composeFilters(fieldName) {
        let filters = [...new Set(jobJournalList.map(note => note[fieldName]))];
        let filtersSort = filters.map(distinctFilters => ({ label: distinctFilters, value: distinctFilters }));
        filtersSort.sort((a, b) => {
          a = a.label || '';
          b = b.label || '';
          return a.toLowerCase().localeCompare(b.toLowerCase());
        });
    
        return filtersSort;
      }

    
    const columns = [
        {
            dataIndex: 'actionsMenu',
            key: 'actionsMenu',
            isDummyField: true,
            title: 'Actions',
            hidden:  isViewOnlyOrExternalView() || project.projectStatus == projectStatusCodeMap['CLOSED'],
            render: (cell, row) => (
                <DropdownButton id={`${row.id}-dropdown`} title='' style={{width: '100%'}} >
                    <Dropdown.Item onClick={() => EditCellFormatter(cell, row)}>Edit</Dropdown.Item>
                    <Dropdown.Item onClick={() => DeleteCellFormatter(cell, row)}>Delete</Dropdown.Item>
                </DropdownButton>
            ),
            style: { textAlign: 'center' },
            headerStyle: { textAlign: 'center' }
        },
        {
            dataIndex: 'title',
            key: 'title',
            title: 'Title',
            render: ViewCellFormatter,
            style: { verticalAlign: 'middle' },
            sorter: (a, b) => {
                a = a.title || '';
                b = b.title || '';
                return a.toLowerCase().localeCompare(b.toLowerCase());
              },
            defaultSortOrder: 'ascend',
            filters: composeFilters('title'),
            ...SearchAndDropdownComponent(),
            onFilter: (value, record) => {
              if (Array.isArray(value)) {
                return (value.includes(record.title))
              } else {
                return (record.title.toLowerCase().includes(value.toLowerCase()) || (value.includes(`${record.title}`)))
              }
            }
        },
        {
            dataIndex: 'dateDiscovered',
            key: 'dateDiscovered',
            title: 'Date Discovered',
            style: { verticalAlign: 'middle' },
            sorter: (a, b) => commonDateSorter(a, b, 'dateDiscovered'),
            filters: composeFilters('dateDiscovered'),
            ...DatePickerAndDropdownComponent(),
            onFilter: (value, record) => {
              if (Array.isArray(value)) {
                return (value.includes(record.dateDiscovered))
              } else {
                return (record.dateDiscovered.toLowerCase().includes(value.toLowerCase()) || (value.includes(`${record.dateDiscovered}`)))
              }
            }
        },
        {
            dataIndex: 'lastModifiedDate',
            key: 'lastModifiedDate',
            title: 'Last Modified Date',
            style: { verticalAlign: 'middle' }
        },
        {
            dataIndex: 'lastModifiedName',
            key: 'lastModifiedName',
            title: 'Last Modified By',
            style: { verticalAlign: 'middle' }
        },
        {
            dataIndex: 'comment',
            key: 'comment',
            title: 'Comments',
            render: CommentCellFormatter,
            style: {textAlign: 'center', verticalAlign: 'middle'},
            headerStyle: { textAlign: 'center' }
        }
    ];

    return ( 
        < >
            {!isViewOnlyOrExternalView() && project.projectStatus !== projectStatusCodeMap['CLOSED'] &&
            <Row className='justify-content-end'>
                <Col style={{ paddingBottom: 8 }}>
                    <button type="button" className="btn btn-primary" onClick={() => handleCreate()}>CREATE NEW JOB JOURNAL </button>
                </Col>
               
            </Row>
            }
            <Row>
            <div className="table-responsive antd-table-custom-css" style={{ overflow: 'hidden'  }}>
                <Table keyField='id'
                                dataSource={jobJournalList}
                                columns={columns.filter( column=> !column.hidden)}
                                bordered
                                pagination={{ showSizeChanger: false, pageSize: 10 }}
                                locale={{ emptyText: (refresh?(<Empty description={(<h6>Loading</h6>)} />):<Empty description={(<h6>No Job Journal Record Found</h6>)} />) }} 
                                loading={refresh}
                                //noDataIndication={() => <NoDataIndication />}
                    />
                    </div>
           </Row>
        </>
    );

}

export default withRouter(JournalList);
